export default "__VITE_ASSET__BoiBvWge__"